import Rev34 from "./Rev34";
import Rev36 from "./Rev36";

// Registry of all public product release pages.
// Add new releases here as they ship, e.g. rev37: Rev37.
const releases = {
	rev34: Rev34,
	rev36: Rev36
};

export default releases;
